import {
  Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/apprelease';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async getLists(params: any) {
    return api.getLists(params);
  }

  @Action
  async add(params: any) {
    return api.add(params);
  }

  @Action
  async edit(params: any) {
    return api.edit(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }

  @Action
  async info(params: any) {
    return api.info(params);
  }

  @Action
  async notice(params: any) {
    return api.notice(params);
  }

  @Action
  async appstore(params: any) {
    return api.appstore(params);
  }

  @Action
  async statistics(params: any) {
    return api.statistics(params)
  }
}
